/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/*
 * Mock for the JS formatter. Ignore formatting of JS content in HTML.
 */
function js_beautify(js_source_text, options) {
    // no formatting
    return js_source_text;
}

export { js_beautify };
